import {biologicalSexOptions} from "../../../../app/Constants";
import OptionLabeledField from "../OptionLabeledField";

export default class BiologicalSexField extends OptionLabeledField {
  constructor(initialValue = undefined) {
    super(biologicalSexOptions, initialValue);
  }
}
